import React, { useState } from 'react';
import softwareErpDevelopmentHero from '../assets/images/main-slider/software-erp-development-hero.png';
import sectionVisualImage from '../assets/images/main-slider/ai-agent-development-hero.png';
import extensionOgImageAsset from '../assets/images/main-slider/ai-agent-development-hero.png';
import ChromeToolsPortfolioPopup from './ChromeToolsPortfolioPopup';
import ServicePageTemplate from './ServicePageTemplate';
import serviceMenuItems, { flattenServiceMenuItems } from './serviceMenuItems';

const chromePortfolioTools = [
  {
    name: 'JD Data Scrapper Tool',
    logo: 'https://www.scrappertool.com/assets/front/images/jd_default_icon_48.png',
    url: 'https://chromewebstore.google.com/detail/jd-data-scrapper-tool/gnjjmhdcbgjopfodapfecjlgedgimebj?hl=en-US',
    text: 'Built for Justdial lead capture, business listings, and faster local prospecting workflows.',
  },
  {
    name: 'FB Data Scrapper Tool',
    logo: 'https://www.scrappertool.com/assets/front/images/fb_default_icon_48.png',
    url: 'https://chromewebstore.google.com/detail/business-leads-scraper-to/pllhgmakfbbbbaelhhoompbffgknkodc',
    text: 'Used for Facebook data workflows, public lead capture, and structured social research.',
  },
  {
    name: 'IndiaMart Lead Manager',
    logo: 'https://www.scrappertool.com/assets/front/images/india_mart_lead_manager_default_icon_48.png',
    url: 'https://chromewebstore.google.com/detail/indiamart-lead-manager-%E2%80%93/jiamhcfmlhjecdkbjehhggpikklgcbfk',
    text: 'Created to organize IndiaMART enquiries, lead follow-up, and browser-based sales support.',
  },
  {
    name: 'ZaubaCorp Scrapper Tool',
    logo: 'https://www.scrappertool.com/assets/front/images/ZaubaCorp_default_icon_48.png',
    url: 'https://chrome.google.com/webstore/detail/zaubacorp-scrapper-tool/dibndfigklgcnpakhfdpcknaggmedmgd',
    text: 'Tailored for company data extraction, business lookup, and compliance-oriented research tasks.',
  },
  {
    name: 'SellerMart Scrapper Tool',
    logo: 'https://www.scrappertool.com/assets/front/images/india_mart_default_icon_48.jpeg',
    url: 'https://chromewebstore.google.com/detail/sellermart-data-scrapper/dlblgeifoilnopmebeionajclfhaobip',
    text: 'Designed for marketplace data collection, seller research, and repeatable lead extraction tasks.',
  },
  {
    name: 'G-map Data Scrapper Tool',
    logo: 'https://www.scrappertool.com/assets/front/images/gmap_default_icon_48.png',
    url: 'https://www.scrappertool.com/services/g-map-data-scrapper.html',
    text: 'Built for Google Maps listing extraction, local business research, and territory mapping.',
  },
  {
    name: 'Trade-In Data Scrapper Tool',
    logo: 'https://www.scrappertool.com/assets/front/images/trade_in_default_icon_48.jpeg',
    url: 'https://chromewebstore.google.com/detail/trade-in-data-scrapper-to/lmlbdcjiiffpjambecniepccffleepmd',
    text: 'Made for TradeIndia workflows, supplier discovery, and industrial data collection at scale.',
  },
];

const chromeExtensionConfig = {
  seo: {
    title: 'Hire Chrome Extension Developer | SwiftMaze Technology',
    description:
      'Hire Chrome extension developer services from SwiftMaze Technology for workflow automation, browser-based tools, secure data handling, and custom business extensions.',
    canonical: 'https://www.swiftmazetech.com/services/hire-chrome-extension-developer/',
    ogImage: extensionOgImageAsset,
    schemaName: 'Hire Chrome Extension Developer',
  },
  servicePath: '/services/hire-chrome-extension-developer/',
  relatedItems: flattenServiceMenuItems(serviceMenuItems),
  hero: {
    image: softwareErpDevelopmentHero,
    kicker: 'Chrome Extension Services',
    title: 'Hire Chrome Extension Developer',
    lead:
      'Build browser tools that reduce repetitive work, speed up lead handling, and connect directly with the systems your team already uses.',
    buttonLabel: 'Discuss Your Extension',
    buttonSubject: 'Hire Chrome Extension Developer',
    chips: [
      'Workflow Automation',
      'Lead Handling',
      'Secure Data Flow',
      'API Integration Ready',
    ],
  },
  capability: {
    id: 'chrome-extension-capabilities',
    kicker: 'What We Build',
    title: 'Custom Chrome Extensions Designed Around Real Team Work',
    text:
      'The goal is not to add complexity inside the browser. The goal is to remove repeated steps, keep actions consistent, and make browser-driven processes faster for your business.',
    items: [
      {
        icon: 'fa-cogs',
        title: 'Workflow Automation',
        text: 'Auto-fill forms, trigger repeated browser actions, and remove manual copy-paste work from daily operations.',
      },
      {
        icon: 'fa-database',
        title: 'Lead And Data Handling',
        text: 'Collect structured data from websites, move it into your CRM, and export clean CSV or Excel-ready outputs when required.',
      },
      {
        icon: 'fa-comments-o',
        title: 'Communication Helpers',
        text: 'Build browser tools for WhatsApp, email, follow-up steps, and quick response actions used by sales and support teams.',
      },
      {
        icon: 'fa-desktop',
        title: 'Clean User Interface',
        text: 'Create popup screens, options pages, and dashboards that feel simple, fast, and easy for real users to operate.',
      },
      {
        icon: 'fa-refresh',
        title: 'Stable Background Logic',
        text: 'Use background scripts, queues, and controlled workflows so your extension keeps running reliably across real business tasks.',
      },
      {
        icon: 'fa-shield',
        title: 'Secure Data Handling',
        text: 'Manage permissions, storage, and API communication carefully so browser-based tools stay dependable and business-safe.',
      },
    ],
  },
  cta: {
    id: 'chrome-extension-plan',
    kicker: 'Need A Browser Tool?',
    title: "Let's Plan The Chrome Extension Around Your Actual Workflow",
    text:
      'Share the task your team repeats in the browser, the data you need to collect, or the process you want to simplify. We will help define the right extension structure before development.',
    buttonLabel: 'Plan Your Extension',
    buttonSubject: 'Hire Chrome Extension Developer',
    secondaryButtonLabel: 'View Built Tools',
    secondaryButtonAction: 'showPortfolio',
    secondaryButtonIcon: 'fa-th-large',
    secondaryFirst: true,
  },
  audience: {
    id: 'chrome-extension-audience',
    image: sectionVisualImage,
    imageAlt: 'Teams using browser-based workflows and digital operations',
    imageStyle: { objectPosition: '22% center' },
    kicker: 'Who It Helps',
    title: 'Extensions That Fit Sales, Marketing, Operations, And Internal Tools',
    text:
      'A custom browser extension works best when it is tied to a clear workflow. We design around the exact screens your team uses, the actions they repeat, and the data that needs to move from one place to another.',
    items: [
      {
        icon: 'fa-line-chart',
        title: 'Sales Teams',
        text: 'For faster prospecting, lead collection, outreach support, and browser-based sales operations.',
      },
      {
        icon: 'fa-bullhorn',
        title: 'Marketing Teams',
        text: 'For campaign research, data capture, competitor tracking, and repetitive reporting workflows.',
      },
      {
        icon: 'fa-cogs',
        title: 'Operations Teams',
        text: 'For internal process automation, data movement, status updates, and portal-based routine work.',
      },
      {
        icon: 'fa-laptop',
        title: 'Product Businesses',
        text: 'For building useful browser extensions as paid tools, internal software, or customer-facing utility products.',
      },
    ],
  },
  delivery: {
    id: 'chrome-extension-delivery',
    kicker: 'Delivery Standard',
    title: 'How We Keep The Final Extension Practical And Professional',
    text:
      'Good extension work is not only about code. It is about making the browser tool understandable, maintainable, and reliable for daily business use.',
    items: [
      {
        number: '01',
        title: 'Plan The Workflow First',
        text: 'We map the exact browser actions, data movement, and user flow before development starts.',
      },
      {
        number: '02',
        title: 'Build For Real Usage',
        text: 'The extension is designed around actual team tasks so it stays practical instead of becoming a demo-only tool.',
      },
      {
        number: '03',
        title: 'Keep It Maintainable',
        text: 'Structure, UI, and logic stay easy to extend when your workflow grows or the target website changes.',
      },
    ],
  },
  faq: {
    kicker: 'FAQ',
    title: 'Questions Clients Ask Before Chrome Extension Development',
    text:
      'Clear answers help you evaluate the workflow, integration scope, and business fit before you start.',
    items: [
      {
        question: 'What type of Chrome extensions can SwiftMaze Technology build?',
        answer:
          'We build workflow automation tools, scraping helpers, CRM-connected browser extensions, admin panel utilities, lead capture tools, reporting helpers, and internal browser-based productivity extensions.',
      },
      {
        question: 'Can you build a Chrome extension similar to our current manual browser process?',
        answer:
          'Yes. We first understand the exact clicks, forms, screens, and data movement in your current process, then design the extension around that real workflow instead of building a generic demo.',
      },
      {
        question: 'Do you support API integration, CSV export, and CRM sync inside Chrome extensions?',
        answer:
          'Yes. We can connect browser extensions with APIs, webhooks, Google Sheets, CSV or Excel exports, and CRMs when the workflow requires reliable data movement.',
      },
      {
        question: 'Is Chrome extension development useful for sales and operations teams?',
        answer:
          'It is especially useful for sales, operations, support, marketing, and internal teams that repeat browser tasks every day and want faster execution with fewer manual errors.',
      },
    ],
  },
  reviews: {
    kicker: 'Reviews',
    title: 'What Clients Say About Our Chrome Extension Work',
    text:
      'Feedback from Indian and international teams that needed practical browser tools for real operations.',
    hideQuote: true,
    items: [
      {
        name: 'Harshil Patel',
        position: 'Operations Manager, India',
        rating: 5,
        message:
          'SwiftMaze converted our repetitive browser workflow into one clean Chrome extension. The team focused on real usage, not just a technical demo.',
      },
      {
        name: 'Emily Carter',
        position: 'Growth Lead, United Kingdom',
        rating: 5,
        message:
          'The extension was delivered with practical UI, stable background logic, and the exact data flow our team needed for daily outreach work.',
      },
      {
        name: 'Rahul Mehta',
        position: 'Business Development Head, India',
        rating: 5,
        message:
          'We needed browser automation tied to lead handling and exports. SwiftMaze planned the workflow properly and built something our team could use immediately.',
      },
      {
        name: 'Sophie Nguyen',
        position: 'Product Operations Specialist, Australia',
        rating: 5,
        message:
          'Good communication, strong understanding of browser-based workflows, and a professional implementation. The final extension felt production-ready.',
      },
    ],
  },
  inquiry: {
    defaultSubject: 'Hire Chrome Extension Developer',
    formTitle: 'Plan Your Chrome Extension',
    formSubtitle:
      'Fill in the same enquiry details and our team will contact you with the right next steps.',
    trackingFormName: 'hire-chrome-extension-developer inquiry form',
  },
};

const ServiceExtension = () => {
  const [isPortfolioOpen, setIsPortfolioOpen] = useState(false);

  return (
    <ServicePageTemplate
      {...chromeExtensionConfig}
      customActions={{
        showPortfolio: () => setIsPortfolioOpen(true),
      }}
    >
      <ChromeToolsPortfolioPopup
        isOpen={isPortfolioOpen}
        onClose={() => setIsPortfolioOpen(false)}
        tools={chromePortfolioTools}
        title="Popular Chrome Extension Tools We Have Built"
        subtitle="These are the live-style Chrome extension tools we have built for directory scraping, marketplace research, map data, and browser-based lead workflows."
      />
    </ServicePageTemplate>
  );
};

export default ServiceExtension;
